import React from 'react';
import image from './rsz_header.png';
import styles from './BackgroundImage.module.scss';

export const BackgroundImage = (props) => {
  return (
    <img src={image} alt="React Logo" className={styles.container}/>
  );
};

BackgroundImage.propTypes = {}

BackgroundImage.defaultProps = {}

export default React.memo(BackgroundImage);